module.exports = __webpack_public_path__ + "img/question-one.64d887ac.jpg";